import { general } from './general';

export const branch = (data = {}) => general('branch', (data || {}));
